import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@mint-lib/query-client';

import type { FileAccess } from '../types/rag.js';

const EMPTY_FILE_ACCESS: FileAccess = Object.freeze({
  accessType: 'invited',
  users: [],
});

export const getFileAccessQueryKey = (fileId: string) =>
  ['rag', 'file-access', fileId] as const;

export const getFileAccessOption = (fileId: string) =>
  queryOptions({
    queryKey: getFileAccessQueryKey(fileId),
    queryFn: () => Promise.resolve(EMPTY_FILE_ACCESS),
    initialData: EMPTY_FILE_ACCESS,
    staleTime: Infinity,
    gcTime: Infinity,
  });

export const useUpdateFileAccessMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ access }: { fileId: string; access: FileAccess }) =>
      Promise.resolve(access),
    onSuccess: (access, { fileId }) => {
      queryClient.setQueryData(getFileAccessQueryKey(fileId), access);
    },
  });
};
